import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const lowes_invoiced = ({ event: { kind, data: { invoice_number } } }) =>
  <div className={kind}>
    Invoice created in quickbooks with invoice number: {invoice_number}
  </div>;

lowes_invoiced.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      invoice_number: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/lowes_invoiced.jsx